export function RequestAudit(key, value) {
  this.key = key || '';
  this.value = value || '';
}
